(function() {
	ko.components.register('player-volume-control', {
		template: { element: 'template-player-volume-control' },
		viewModel: function(params) {
			this.volume = params.volume;
			this.muted = params.muted;

			this.isHover = ko.observable(false);
			this.isDrag = ko.observable(false);

			this.isMuted = ko.computed(() => this.muted() || this.volume() === 0);

			this.setVolume = volume => params.setVolume(volume);

			this.onClickMuted = () => params.setMuted();
			this.onClickVolume = (context, event) => this.setVolume(event.offsetX / $(event.currentTarget).width());

			this.onMouseEnter = () => this.isHover(true);
			this.onMouseLeave = () => this.isHover(false);

			this.onMouseDown = (viewModel, dragStartEvent) => {
				const options = {
					min: 0,
					max: 1
				};

				const onDrag = dragEvent => {
					const target = $(dragStartEvent.target);
					let x = (dragEvent.pageX - target.offset().left) / target.width();

					if(x < options.min) x = options.min;
					else if(x > options.max) x = options.max;

					this.setVolume(x);
				};

				const onDragEnd = () => {
					$(document).off('mousemove', onDrag);
					$(document).off('mouseup', onDragEnd);
					this.isDrag(false);
				};

				$(document).on('mousemove', onDrag);
				$(document).on('mouseup', onDragEnd);
				this.isDrag(true);
				onDrag(dragStartEvent);
			};
		}
	});
})();